const Config = {
  VERSION: "1.0.0",
  OKTA_ISSUER: "https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7",
}
export default Config
